import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { APP_STATES } from '@config';
import { EventManager, EVENTS } from '@components/Events/events';

export default class Accordion extends Component {

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onItemClick: PropTypes.func,
    appStatus: PropTypes.string,
    activeItem: PropTypes.string,
    onRef: PropTypes.func
  };

  static defaultProps = {
    className: '',
    onItemClick: null,
    appStatus: APP_STATES.NOT_INITIALIZED
  };

  constructor(props) {
    super(props);

    this.state = {
      activeChildId: props.activeItem || null
    };

    this.onTabSwitched = this.onTabSwitched.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.appStatus === APP_STATES.INITIALIZED) {
      if (props.children.length &&
      (!state.activeChildId || 
        (state.activeChildId.indexOf("_Closed") === -1 && 
        !props.children.some((c) => c && c.props && c.props.id === state.activeChildId)))){
      
        return {
          activeChildId: props.children.find(c => { return c !== false; }).props.id
        };
      } else if (!props.children.length && // VladP: React doesn't create an array for children if it contains only 1 element
        (!state.activeChildId || 
        (state.activeChildId.indexOf("_Closed") === -1 && 
        !props.children.props.id === state.activeChildId))) {

          return {
            activeChildId: props.children.props.id
          };
        }
    } else if (props.appStatus === APP_STATES.LOADING_NEW_STATE && props.activeItem) {
      // set the active accordion item from the loaded state
      return {
        activeChildId: props.activeItem
      };
    }

    return null;
  }

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this);
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null);
  }

  render() {
    let children = this.props.children && this.props.children.length ? this.props.children : [this.props.children];

    return (
      <div className={this.props.className}>
        <ul className="accordion-list">
          {
            children.map((item) => {
              if (item) {
                const newProps = {
                  key: item.props.id,
                  onClick: (id) => {
                    this.onChildClick(id, item.props.id === this.state.activeChildId);
                    item.props.onClick(id);
                  },
                  isActive: item.props.id === this.state.activeChildId 
                };

              return (
                <item.type {...item.props} {...newProps}>
                  {item.props.children}
                </item.type>
              );
            }

              return false;
          })}
        </ul>
      </div>
    );
  }

  onChildClick(id, isActive) {
    var activationAllowed = true;
    if (typeof this.props.onItemClick === 'function') 
      activationAllowed = this.props.onItemClick(id, isActive);

    if (activationAllowed || activationAllowed === null || activationAllowed === undefined) {
      this.onResumeActivation(id);
    } else {
      this.setState({ pendingActivationId: id });
    }
  }

  onTabSwitched(tab) {
    let id = this.state.activeChildId;
    if (id)
      this.setState({
        activeChildId: id.replace("_Closed", "")
      });
  }

  onResumeActivation(activationId) {
    var id = activationId;
    if (id === null || id === undefined) {
      id = this.state.pendingActivationId;
      this.setState({ pendingActivationId: null });
    }

    if (id === this.state.activeChildId) {
      EventManager.removeListener(EVENTS.TAB_SWITCHED, this.onTabSwitched);
      EventManager.once(EVENTS.TAB_SWITCHED, this.onTabSwitched);
      this.setState({
        activeChildId: id + "_Closed"
      });
    } else {
      this.setState({
        activeChildId: id
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/Accordion/index.js